import { ThemeProvider } from '@mui/material';
import { ReactNode, useEffect, useState } from 'react';
import { ThemeContext } from './ThemeContext';
import { darkTheme, lightTheme } from './themes';

export const ThemeProviderWrapper = ({ children }: { children: ReactNode }) => {
  const [isDarkMode, setIsDarkMode] = useState(false);

  useEffect(() => {
    const preferredTheme = localStorage.getItem('preferredTheme');
    setIsDarkMode(preferredTheme === 'dark');
  }, []);

  useEffect(() => {
    // Update the theme color for PWA/iOS Safari status bar
    const metaThemeColor = document.querySelector('meta[name="theme-color"]');
    if (metaThemeColor) {
      metaThemeColor.setAttribute(
        'content',
        isDarkMode ? '#171717' : '#ffffff'
      );
    }
  }, [isDarkMode]);

  const toggleTheme = () => {
    setIsDarkMode((prev) => !prev);
    localStorage.setItem('preferredTheme', isDarkMode ? 'light' : 'dark');
  };

  const handleSetIsDarkMode = (theme: boolean) => {
    setIsDarkMode(theme);
    localStorage.setItem('preferredTheme', theme ? 'dark' : 'light');
  };

  const theme = isDarkMode ? darkTheme : lightTheme;

  return (
    <ThemeContext.Provider
      value={{ isDarkMode, toggleTheme, setIsDarkMode: handleSetIsDarkMode }}
    >
      <ThemeProvider theme={theme}>{children}</ThemeProvider>
    </ThemeContext.Provider>
  );
};
